import React from 'react';

const ImageModal = ({ imageUrl, onClose }) => {
  // This function prevents a click on the image itself from closing the modal
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="image-modal-backdrop" onClick={onClose}>
      <div className="image-modal-content" onClick={handleContentClick}>
        <button className="close-button modal-close" onClick={onClose}>&times;</button>
        {/* The 'img' tag now has inline styles to control its size */}
        <img 
          src={imageUrl} 
          alt="Full size product view"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain' // This is the key property
          }}
        />
      </div>
    </div>
  );
};

export default ImageModal;